import type { FC } from 'react';
import type { ModalInnerProps } from './components/ModalInner';
import { useState } from 'react';
import { ModalInner } from './components/ModalInner';
import { getModalCloseDelay, modalMotionPresets } from './modalMotion';

interface ModalProps extends Omit<ModalInnerProps, 'children' | 'isOpen'> {
  children?: (args: { isOpen: boolean; closeModal: () => void }) => React.ReactNode;
  hideCloseIcon?: boolean;
  headerChild?: React.ReactNode;
  accessibleTitle?: string;
  contentMobileClassName?: string;
  outsideCloseAction?: () => void;
  hideTitle?: boolean;
  disableOutsidePointerEvents?: boolean;
}

const Modal: FC<ModalProps> = ({
  headerChild,
  children,
  onCloseAction,
  onHeaderBack,
  hideCloseIcon,
  contentMobileClassName,
  outsideCloseAction,
  disableOutsidePointerEvents,
  motionPreset = modalMotionPresets.default,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(true);

  const closeModal = () => {
    setIsOpen(false);

    setTimeout(() => {
      onCloseAction();
    }, getModalCloseDelay(motionPreset));
  };

  const onAnimationEnd = () => {
    setTimeout(() => {
      onCloseAction();
    }, 0);
  };

  return (
    <ModalInner
      {...props}
      isOpen={isOpen}
      onCloseAction={outsideCloseAction || closeModal}
      onAnimationEnd={onAnimationEnd}
      onHeaderBack={onHeaderBack}
      headerChild={headerChild}
      contentMobileClassName={contentMobileClassName}
      hideCloseIcon={hideCloseIcon}
      variant={props.variant}
      disableOutsidePointerEvents={disableOutsidePointerEvents}
      motionPreset={motionPreset}
    >
      {children?.({ isOpen, closeModal })}
    </ModalInner>
  );
};

Modal.displayName = 'Modal';

export default Modal;
